import { render, staticRenderFns } from "./monthlive.vue?vue&type=template&id=1a0b3a51&"
import script from "./monthlive.vue?vue&type=script&lang=js&"
export * from "./monthlive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports